import { render } from "./PlatformMetadataEditor.vue?vue&type=template&id=a73c142c"
import script from "./PlatformMetadataEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformMetadataEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformMetadataEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a73c142c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a73c142c', __exports__)) {
    api.reload('a73c142c', __exports__)
  }
  
  module.hot.accept("./PlatformMetadataEditor.vue?vue&type=template&id=a73c142c", () => {
    api.rerender('a73c142c', render)
  })

}


export default __exports__